import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { getshareItineraryDetailsbyEmailData } from "../../Component/axios";
import moment from "moment";
import { PDFDownloadLink } from "@react-pdf/renderer";
import InvoiceItinerary from "./InvoiceItinerary/Invoice";
import { useParams } from "react-router-dom";

function ItineraryShareDownload() {
  const { id } = useParams();
  const shareid = atob(id);

  const [wishlistData, setwishlistData] = useState(null);

  useEffect(() => {
    getshareItineraryDetailsbyEmailData(shareid).then(
      (data) => {
        //console.log(data)
        setwishlistData(data);
      },
      (error) => {}
    );
  }, []);

  return (
    <div className="Detail-container">
      <Helmet>
        <title>Book Best Hotels in seychelles- Holidays Seychelles</title>
        <meta
          name="description"
          content="Book best hotels in Seychelles at affordable prices."
        />
        <meta
          name="keywords"
          content="Seychelles, Seychellen, best place for honeymoon,most beautiful places in the world,best honeymoon destination in the world,honeymoon places,honeymoon destinations,beautiful places in the world"
        />
      </Helmet>
      <h1 style={{ color: "#fff" }}>
        Book Best Hotels in seychelles- Holidays Seychelles
      </h1>
  
      <div className="topSection newTopSection appendBottom20"></div>
      <div class="col-lg-6 col-xxl-4 my-5 mx-auto">
        <div class="d-grid gap-2">
          {wishlistData &&
            wishlistData.map((item, newindex) => {
              const newIteam = JSON.parse(item.plan_details);

              let JsonStatePDFAcco = {
                booking_amount: newIteam?.booking_amount,
                total_main_amount: newIteam?.total_main_amount,
                offer_discount: newIteam?.offer_discount,
                numberof_night: newIteam?.numberof_night,
                agentdetails: newIteam?.agentdetails,
                child: newIteam?.child,
                dayPlan: newIteam?.dayPlan,
                itineraryDetails: newIteam?.itineraryDetails,
                planname: newIteam?.planname,
                totalDays: newIteam?.totalDays,
                startDate: newIteam?.startDate,
                endDate: newIteam?.endDate,
                selectedStartLocation: newIteam?.selectedStartLocation,
                selectedEndLocation: newIteam?.selectedEndLocation,
              };
              const propertypdf = JSON.stringify(JsonStatePDFAcco);

              return (
                <>
                <div class="card">
                  {/* <img class="card-img-top" src="..." alt="Card image cap"> */}
                  <div class="card-body">
                    {/* <h5 class="card-title">Card title</h5> */}
                    {/* <h5 class="card-title">Holidays Seychelles Travel Itinerary has shared the travel itinerary for their upcoming trip to Seychelles. Kindly click on the below button to download and view same.</h5> */}
                    {
                    <PDFDownloadLink
                      document={<InvoiceItinerary invoice={propertypdf} />}
                      fileName="ItineraryDetails.pdf"
                      style={{
                        fontSize: "20px",
                        color: "#ff0000",
                        fontWeight: "800",
                        marginLeft: "25%",
                        border: "1px solid",
                        padding: "10px",
                        borderRadius: "5%",
                      }}
                      class="btn btn-primary"
                    >
                      {({ blob, url, loading, error }) =>
                        loading ? "Loading document..." : "Download Itinerary"
                      }
                    </PDFDownloadLink>
                  }
                  </div>
                </div>
                  
                </>
              );
            })}
        </div>
      </div>
    </div>
  );
}
export default ItineraryShareDownload;
